module.exports = __webpack_public_path__ + "img/sm_02_fb.0a244362.svg";